import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';

// dynamic landing pages
const PeruDevOpsLanding = Loadable(lazy(() => import('views/dynamic-landings/PeruDevOpsLanding')));
const ColombiaDevOpsLanding = Loadable(lazy(() => import('views/dynamic-landings/ColombiaDevOpsLanding')));
const DevOpsCalculatorLanding = Loadable(lazy(() => import('views/dynamic-landings/DevOpsCalculatorLanding')));
const CTOTechnicalCenteredLanding = Loadable(lazy(() => import('views/dynamic-landings/CTOTechnicalCenteredLanding')));
const FullWidthModernLanding = Loadable(lazy(() => import('views/dynamic-landings/FullWidthModernLanding')));
const FlexSavingsLanding = Loadable(lazy(() => import('views/dynamic-landings/FlexSavingsLanding')));
const AllLogosTestLanding = Loadable(lazy(() => import('views/dynamic-landings/AllLogosTestLanding')));
const StartcoLanding = Loadable(lazy(() => import('views/dynamic-landings/StartcoLanding')));
// ==============================|| PREVIEW AD ROUTING ||============================== //

const PreviewRoutes = {
    path: '/',
    children: [
        {
            path: '/landing/1',
            element: <PeruDevOpsLanding />
        },
        {
            path: '/landing/2',
            element: <ColombiaDevOpsLanding />
        },
        {
            path: '/landing/3',
            element: <DevOpsCalculatorLanding />
        },
        {
            path: '/landing/4',
            element: <CTOTechnicalCenteredLanding />
        },
        {
            path: '/landing/5',
            element: <FullWidthModernLanding />
        },
        {
            path: '/landing/6',
            element: <FlexSavingsLanding />
        },
        {
            path: '/landing/99',
            element: <AllLogosTestLanding />
        },
        {
            path: '/flexsavings',
            element: <FlexSavingsLanding />
        },
        {
            path: '/startco',
            element: <StartcoLanding />
        }
    ]
};

export default PreviewRoutes;
